@if (options.content) {
  <pr-content-view [content]="options.content" />
}
